import React from "react";

/* The Login Layout is a public layout, used for the Login, Registration, and Forgot Password pages. This layout does not have a header and a footer. */
const LoginLayout = ({ children }) => <div>{children}</div>;

export default LoginLayout;
